const EventEmitter = require('events')
export const EventBus = new EventEmitter();
EventBus.setMaxListeners(150);
